<template>
    <auth-layout>
        <jet-authentication-card>
            <div class="card">
                <div class="card-header">
                    <logo class="text-center" :show-name="true"/>
                </div>

                <div class="card-body px-5 py-4">
                    <form method="post" @submit.prevent="submit()">
                        <div class="form-group">
                            <label for="email">Email Address</label>
                            <input class="form-control"
                                   id="email"
                                   type="email"
                                   v-model="form.email"
                                   :disabled="form.processing"
                                   placeholder="email@domain.com">
                            <error-line field="email"/>
                        </div>
                        <div class="form-group">
                            <label for="password">Password</label>
                            <input class="form-control"
                                   id="password"
                                   type="password"
                                   v-model="form.password"
                                   :disabled="form.processing"
                                   placeholder="Secret Password">
                            <error-line field="password"/>
                        </div>

                        <div class="form-group">
                            <state-button type="submit"
                                          :disabled="form.processing"
                                          :state="form.processing ? 'busy' : ''"
                                          class="btn btn-primary">Create Account</state-button>
                        </div>
                    </form>
                </div>
            </div>
        </jet-authentication-card>
    </auth-layout>
</template>

<script>
import JetAuthenticationCard from '@/Jetstream/AuthenticationCard'
import JetAuthenticationCardLogo from '@/Jetstream/AuthenticationCardLogo'
import JetButton from '@/Jetstream/Button'
import JetInput from '@/Jetstream/Input'
import JetCheckbox from '@/Jetstream/Checkbox'
import JetLabel from '@/Jetstream/Label'
import JetValidationErrors from '@/Jetstream/ValidationErrors'
import helpers from "@/mixins/helpers";
import AuthLayout from "@/Layouts/AuthLayout";
import Logo from "@/Components/Common/Logo";
import PublicLayout from "@/Layouts/PublicLayout";
import ErrorLine from "@/Components/Common/ErrorLine";
import StateButton from "@/Components/Common/StateButton";
import mixpanel from "mixpanel-browser";
import utils from "@/mixins/utils";

export default {
    name: "CreatePassword",
    components: {StateButton, ErrorLine, PublicLayout},
    props: ['email'],
    mixins: [utils],

    data(){
        return {
            form: this.$inertia.form({
                email: null,
                password: null,
            }),
        }
    },

    methods: {
        submit(){

            this.form.post(this.route('onboard.create-account', {...this.global_url_params}), {
                onSuccess: (res) => {
                    mixpanel.track('REGISTER', this.utils.flatten(res.props.user));
                    mixpanel.identify(res.props.user.id);
                },
            });
        }
    },

    mounted() {
        this.form.email = this.email;

        this.setTitle('Create Account');
    }

}
</script>

<style lang="scss" scoped>
.card{
    margin: 3rem auto;
    max-width: 600px;
}
</style>
